var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app"},[_c('reports-drawer',{ref:"drawer",staticClass:"app--drawer"}),_c('v-main',[_c('router-view')],1),_c('app-fab')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }